import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase";

export async function assistantAction(name, data = {}) {
  const result = await httpsCallable(getFunctions(undefined, "us-central1"), name,
    { timeout: name === "generateArtworkDraft" ? 310000 : 95000 })(data);
  return result.data;
}
export function watchAssistant(artworkId, receive, error) {
  const stops = [
    onSnapshot(doc(db, "vehicleArtwork", artworkId, "assistant", "state"),
      (snapshot) => receive("state", snapshot.data() || {}), error),
    onSnapshot(collection(db, "vehicleArtwork", artworkId, "sourceReferences"),
      (snapshot) => receive("references", snapshot.docs.map((item) => ({ ...item.data(), id: item.id }))), error),
    onSnapshot(query(collection(db, "artworkGenerationJobs"), where("artworkId", "==", artworkId)),
      (snapshot) => receive("jobs", snapshot.docs.map((item) => ({ ...item.data(), id: item.id }))
        .sort((a, b) => b.attempt - a.attempt)), error),
  ];
  return () => stops.forEach((stop) => stop());
}
export async function uploadReference(artworkId, file, metadata) {
  if (!file || !["image/png", "image/jpeg"].includes(file.type) || !file.size || file.size > 5 * 1024 * 1024) {
    throw new Error("Choose a PNG or JPEG up to 5 MB.");
  }
  const uploadId = crypto.randomUUID();
  await uploadBytes(ref(storage, `vehicleArtworkReferenceUploads/${artworkId}/${uploadId}/reference`), file,
    { contentType: file.type });
  return assistantAction("selectArtworkReference", { artworkId, uploadId, ...metadata });
}
